import React, { useState } from 'react';
import styles from './deleteStatisticsData.css';
import Popup from '../../../../../../../components/common/popUp/PopUp';
import CustomRadio from '../../../../../../../components/common/customRadio/CustomRadio';
import { useDispatch } from 'react-redux';
import { deleteCalendarAllUserPlayers } from '../../../../../../../data/calendar/players/actions';
import { statisticsCalendar } from '../../../../../../../data/statistics/calendar/actions';

/**
 *
 * @type {React.NamedExoticComponent<{readonly closePopupDeleteStatisticsData?: *, readonly content?: *, readonly calendarID?: *}>}
 */
const DeleteStatisticsData = React.memo( ( { calendarID, closePopupDeleteStatisticsData, content } ) => {
    const [ typeDeleteData, setTypeDeleteData ] = useState( '' );

    const dispatch = new useDispatch();

    const handleChangeDeletingUsers = ( e, { value } ) => {
        setTypeDeleteData( value );
    };

    const deleteData = () => {
        if ( typeDeleteData === 'games' ) {
            return new Promise( ( resolve ) => {
                dispatch( deleteCalendarAllUserPlayers( calendarID, typeDeleteData, false, resolve ) );
            } ).then( e => {
                if ( e.status === 200 ) {
                    dispatch( statisticsCalendar( calendarID ) );
                    closePopupDeleteStatisticsData();
                }
            } );

        } else {
            dispatch( deleteCalendarAllUserPlayers( calendarID, typeDeleteData, true ) );
        }
        closePopupDeleteStatisticsData();
    };


    return (
        <Popup
            handleClose={ closePopupDeleteStatisticsData }
            windowStyle={ {
                height: '290px',
                width: '490px',
                padding: '40px 20px',
                borderRadius: '0.5rem',
                backgroundColor: '#fff',
                boxShadow: '0 0.5rem 6.4rem 0 rgba(0, 0, 0, 0.24)'
            } }
        >
            <p className={ styles.title }>{ content.calendar.do_you_want_to_delete_the_calendar_statistics }</p>
            <div className={ styles.wrapperRadio }>
                <CustomRadio
                    label={ content.calendar.delete_calendar_statistics }
                    value={ 'games' }
                    checked={ typeDeleteData === 'games' }
                    onChange={ handleChangeDeletingUsers }
                    className={ styles.radio }
                />
                <CustomRadio
                    label={ content.calendar.delete_both_calendar_statistics_and_player_data }
                    value={ 'players' }
                    checked={ typeDeleteData === 'players' }
                    onChange={ handleChangeDeletingUsers }
                    className={ styles.radio }
                />
            </div>
            <div className={ styles.buttonBox }>
                <button className={ styles.button } onClick={ closePopupDeleteStatisticsData }>
                    { content.dashboard.cancel }
                </button>
                <button
                    className={ typeDeleteData ? styles.button : `${ styles.desabledButton } ${ styles.button }` }
                    onClick={ deleteData }>
                    { content.dashboard.delete }
                </button>
            </div>
        </Popup>
    );
} );

export default DeleteStatisticsData;
